module.exports = __webpack_public_path__ + "media/images/responsive/lp/clean/promise_10-8f0f7a9c4c4dc6a67e1fd51c2031e9cc.png";